module.exports = __webpack_public_path__ + "static/media/Inter-Bold.3e3cb905.ttf";